<template>
  <div>
    <b-modal
      ref="modal-primary "
      id="modal-primary"
      modal-class="modal-primary"
      centered
      size="xl"
      title="Rapor Detayı"
      hide-footer
    >
      <div id="invoice-page">
        <div class="items-center justify-between">
          <div class="items-center">
            <b-row>
              <b-col cols="10"
                ><b-card-text> Cari Adı: {{ ACTNAME }} </b-card-text></b-col
              >
              <b-col cols="2">
                <download-excel
                  class="btn btn-default"
                  :data="rowData"
                  name="excelData.xls"
                  style="
                    width: 75px;
                    height: 25px;
                    text-align: center;
                    padding: 0px;
                    color: white;
                    border-style: solid;
                    border-color: #0d6efd;
                    border-radius: 5px;
                    background-color: #0d6efd;
                  "
                >
                  Excel
                </download-excel>
              </b-col>
            </b-row>

            <vs-divider color="Default"> </vs-divider>
            <b-row style="margin-bottom: 10px">
              <b-col lg="3" sm="6">
                <ButtonPrimary
                  :title="filtretitle"
                  :size="filtresize"
                  @test-click="resetState"
                  :color="filtrecolor"
                />
              </b-col>
            </b-row>
            <ag-grid-vue
              style="width: 100%; height: 450px"
              class="ag-theme-alpine"
              :defaultColDef="defaultColDef"
              :columnDefs="columnDefs"
              :rowData="rowData"
              :localeText="localeText"
              :pagination="true"
              @grid-ready="onGridReady"
              @first-data-rendered="onFirstDataRendered"
              :pinnedBottomRowData="pinnedBottomRowData"
            >
            </ag-grid-vue>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import ExcelYazdirComponent from "../ExcelYazdirComponent.vue";
import ButtonPrimary from "../global-components/ButtonPrimary.vue";

export default {
  data() {
    return {
      filtresize: "small",
      filtretitle: "Filtrelemeyi Resetle",
      filtrecolor: "success",
      pinnedBottomRowData: null,
      bottomData: null,
      ACTNAME: "",
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: null,
      columnDefsBottom: null,
      rowData: null,
      localeText: null,
      popupKartDetay: false,
      bottomGridOptions: null,
      rowStyle: { fontWeight: "bold" },
    };
  },
  components: {
    ButtonPrimary,
    ExcelYazdirComponent,
    AgGridVue,
  },
  created() {
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
  },
  methods: {
    createData(count, prefix) {
      var result = [];

      result.push({
        TRANSDATE: "",
        RECEIPTNO: "",
        DUEDATE: "",
        DESCRIPTION: "",
        farkgun: "",
        FaturaTutar: "",
        TUTAR: this.BAKIYE,
      });

      return result;
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return "Toplam";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    parseDate(params) {
      if (params.value == "") return "";
      else return moment(String(params.value)).format("DD.MM.YYYY");
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    resetState() {
      this.gridApi.setFilterModel(null);
      this.gelenfiltre = "";
      this.rpAcikFaturalarDetay();
    },
    rpAcikFaturalarDetay(item, ACTNAME, BAKIYE) {
      this.$refs["modal-primary "].show();

      this.ACTNAME = ACTNAME;
      this.BAKIYE = BAKIYE;

      this.pinnedBottomRowData = this.createData(1, "Bottom");

      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
        ACTID: item,
      };
      soap.createClient(url, function (err, client) {
        client.rpAcikFaturalarDetay(args, function (err, result) {
          if (result.rpAcikFaturalarDetayResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.rpAcikFaturalarDetayResult);
            vm.rowData = vm.veriler;
          } catch (error) {}
        });
      });
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Tarih",
        field: "TRANSDATE",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: this.parseDate,
      },
      {
        headerName: "Fatura No",
        field: "FATURANO",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Vade Tarihi",
        field: "DUEDATE",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: this.parseDate,
      },
      {
        headerName: "Fark Gün",
        field: "farkgun",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Açıklama",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "DESCRIPTION",
      },
      {
        headerName: "Fatura Tutar",
        field: "FaturaTutar",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.FaturaTutar, "₺"),
      },
      {
        headerName: "Kalan",
        field: "TUTAR",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.TUTAR, "₺"),
        type: "rightAligned",
        cellRendererSelector: (params) => {
          if (params.node.rowPinned) {
            return {
              params: {
                style: { color: "blue" },
              },
            };
          } else {
            // rows that are not pinned don't use any cell renderer
            return undefined;
          }
        },
      },
    ];
  },
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
[dir] button:not(:disabled),
[dir] [type="button"]:not(:disabled),
[dir] [type="reset"]:not(:disabled),
[dir] [type="submit"]:not(:disabled) {
  cursor: pointer;
  border: none;
}
</style>